import React, { useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import "./HeroSwiper.css";

// 🔧 EDIT YOUR SLIDES HERE — each slide is { img, link }.
//    `link` can be an internal route ("/vision-mission") or an external URL ("https://…").
import slide1 from "../../../assets/images/Carousel/c1.png";
import slide2 from "../../../assets/images/Carousel/c2.png";
import slide3 from "../../../assets/images/Carousel/c3.png";
import slide4 from "../../../assets/images/Carousel/c4.png";

const SLIDES = [
  { img: slide1, link: "/company-profile" },
  { img: slide2, link: "/technical-analysis" },
  { img: slide3, link: "/trading-dashboard/PSX" },
  { img: slide4, link: "/software-download" },
];

const AUTOPLAY_MS = 5000;

const Chevron = ({ dir }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    {dir === "left" ? <polyline points="15 18 9 12 15 6" /> : <polyline points="9 18 15 12 9 6" />}
  </svg>
);

const HeroSwiper = () => {
  const history = useHistory();
  const [idx, setIdx] = useState(0);
  const n = SLIDES.length;
  const timer = useRef(null);
  const startX = useRef(null);
  const suppressClick = useRef(false); // avoid navigating right after a swipe

  const next = useCallback(() => setIdx(p => (p + 1) % n), [n]);
  const prev = useCallback(() => setIdx(p => (p - 1 + n) % n), [n]);
  const goTo = (i) => setIdx((i + n) % n);

  const start = useCallback(() => {
    clearInterval(timer.current);
    timer.current = setInterval(next, AUTOPLAY_MS);
  }, [next]);
  const stop = () => clearInterval(timer.current);

  useEffect(() => { start(); return stop; }, [start]);

  const openLink = (link) => {
    if (suppressClick.current) { suppressClick.current = false; return; }
    if (!link) return;
    if (/^https?:\/\//i.test(link)) window.open(link, "_blank", "noopener");
    else history.push(link);
  };

  if (n === 0) return null;

  return (
    <div
      className="hsw"
      onMouseEnter={stop}
      onMouseLeave={start}
      onTouchStart={(e) => { startX.current = e.touches[0].clientX; stop(); }}
      onTouchEnd={(e) => {
        const dx = e.changedTouches[0].clientX - (startX.current ?? 0);
        if (Math.abs(dx) > 50) { suppressClick.current = true; dx > 0 ? prev() : next(); }
        start();
      }}
    >
      <div className="hsw-track" style={{ transform: `translateX(-${idx * 100}%)` }}>
        {SLIDES.map((s, i) => (
          <div
            key={i}
            className="hsw-slide"
            style={{ cursor: s.link ? "pointer" : "default" }}
            role={s.link ? "link" : "img"}
            aria-label={`Slide ${i + 1}`}
            onClick={() => openLink(s.link)}
          >
            {/* blurred backdrop fills empty space for off-ratio images */}
            <div className="hsw-slide-bg" style={{ backgroundImage: `url(${s.img})` }} />
            {/* full image, never cropped */}
            <img className="hsw-slide-img" src={s.img} alt={`Slide ${i + 1}`} draggable="false" />
          </div>
        ))}
      </div>

      <button className="hsw-arrow left" onClick={prev} aria-label="Previous slide"><Chevron dir="left" /></button>
      <button className="hsw-arrow right" onClick={next} aria-label="Next slide"><Chevron dir="right" /></button>

      <div className="hsw-dots">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`hsw-dot${i === idx ? " active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSwiper;
